function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from "src/session/AuthProvider";
import { AppContext } from "src/contexts/contexts";
import { _get, isHttpWithData } from "nood-comp/src/net/xhr";
export default function AppContextProvider(props) {
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    appTiers = _useState2[0],
    setAppTiers = _useState2[1];
  var _useContext = useContext(AuthContext),
    user = _useContext.user;
  useEffect(function () {
    if (user) {
      /*propertyModifier.__get({
        entity: `app`,
        properties: ['tier_1_name', 'tier_2_name', 'tier_3_name']
      }).then((properties: {
        property: string,
        value: string
      }[]) => {
        setAppTiers({
          "1": {
            name: properties.find(p => p.property === 'tier_1_name')?.value
          },
          "2": {
            name: properties.find(p => p.property === 'tier_2_name')?.value
          },
          "3": {
            name: properties.find(p => p.property === 'tier_3_name')?.value
          },
        })
      })*/
      _get("/tiers?s=tier_num:asc", function (res) {
        if (isHttpWithData(res)) {
          var finalTierObj = res.data.reduce(function (finalTierData, tier) {
            finalTierData["".concat(tier.tier_num)] = tier;
            return finalTierData;
          }, {});
          setAppTiers(finalTierObj);
        }
      });
    } else {
      setAppTiers(undefined);
    }
  }, [user]);
  var _getTier = function _getTier(tier) {
    return appTiers[tier.toString()];
  };
  return /*#__PURE__*/React.createElement(AppContext.Provider, {
    value: {
      appTiers: appTiers,
      _getTier: _getTier
    }
  }, props.children);
}